import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'dashboard-contact-gender',
  storeModule.createStoreModule('dashboard-contact-gender', {
    fetchListURL: 'dashboard/contact-gender'
  })
)
